import { useEffect } from 'react';
import { useI18n } from '../i18n.js';
import { trackPageView } from '../analytics.js';

interface NotFoundPageProps {
  onGoHome: () => void;
}

export function NotFoundPage({ onGoHome }: NotFoundPageProps) {
  const { lang } = useI18n();
  const isMn = lang === 'mn';

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = isMn
        ? '404 - Хуудас олдсонгүй | arvangurav.com'
        : '404 - Page Not Found | arvangurav.com';
      trackPageView('/404', '404 - Page Not Found');
    }
  }, [isMn]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '32px 16px',
        textAlign: 'center',
        color: '#f8fafc',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(145deg, rgba(16, 27, 22, 0.95), rgba(7, 26, 16, 0.95))',
          border: '1px solid rgba(251, 191, 36, 0.35)',
          borderRadius: 16,
          padding: '36px 28px',
          maxWidth: 480,
          width: '100%',
          boxShadow: '0 20px 50px rgba(0,0,0,0.6)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <div style={{ fontSize: '3.5rem', lineHeight: 1 }}>🃏</div>
        <div
          style={{
            fontSize: '3rem',
            fontWeight: 900,
            letterSpacing: 2,
            background: 'linear-gradient(135deg, #fde68a, #fbbf24, #d97706)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            margin: 0,
          }}
        >
          404
        </div>
        <h1
          style={{
            fontSize: '1.3em',
            margin: 0,
            color: '#fde68a',
            fontWeight: 700,
          }}
        >
          {isMn ? 'Хуудас олдсонгүй' : 'Page Not Found'}
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: '0.92em',
            lineHeight: 1.5,
            color: 'rgba(255,255,255,0.75)',
            maxWidth: 360,
          }}
        >
          {isMn
            ? 'Таны хайсан хуудас устгагдсан эсвэл хаяг буруу байна. Нүүр хуудас руу буцан тоглоомоо үргэлжлүүлнэ үү.'
            : 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'}
        </p>
        <button
          type="button"
          onClick={onGoHome}
          style={{
            marginTop: 8,
            background: 'var(--accent-color, #fbbf24)',
            color: '#000',
            fontWeight: 800,
            fontSize: '0.95em',
            padding: '10px 24px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(251, 191, 36, 0.35)',
            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
          }}
        >
          🏠 {isMn ? 'Нүүр хуудас руу буцах' : 'Return to Home'}
        </button>
      </div>
    </div>
  );
}
